import React from 'react';
import type { ISnapIcon } from '../icons-mapper';

export const Ban = (props: ISnapIcon) => {
  const { size, title, color = 'currentColor' } = props;
  return (
    <svg
      height={size}
      width={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.96496 4.90396L15.096 14.035C16.0855 12.7853 16.5814 11.2155 16.4893 9.62415C16.3972 8.03277 15.7235 6.53072 14.5964 5.40356C13.4692 4.2764 11.9672 3.60273 10.3758 3.51062C8.78439 3.4185 7.21464 3.91438 5.96496 4.90396ZM14.035 15.096L4.90396 5.96496C3.91438 7.21464 3.4185 8.78439 3.51062 10.3758C3.60273 11.9672 4.2764 13.4692 5.40356 14.5964C6.53072 15.7235 8.03277 16.3972 9.62415 16.4893C11.2155 16.5814 12.7853 16.0855 14.035 15.096ZM4.34296 4.34296C5.08585 3.60007 5.96779 3.01078 6.93842 2.60874C7.90905 2.20669 8.94936 1.99976 9.99996 1.99976C11.0506 1.99976 12.0909 2.20669 13.0615 2.60874C14.0321 3.01078 14.9141 3.60007 15.657 4.34296C16.3998 5.08585 16.9891 5.96779 17.3912 6.93842C17.7932 7.90905 18.0002 8.94936 18.0002 9.99996C18.0002 11.0506 17.7932 12.0909 17.3912 13.0615C16.9891 14.0321 16.3998 14.9141 15.657 15.657C14.1566 17.1573 12.1217 18.0002 9.99996 18.0002C7.87818 18.0002 5.84329 17.1573 4.34296 15.657C2.84263 14.1566 1.99976 12.1217 1.99976 9.99996C1.99976 7.87818 2.84263 5.84329 4.34296 4.34296Z'
        fill={color}
      />
    </svg>
  );
};
